import { useContext, useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from "yup";
import { UserCompanyInfo, initialUserCompanyInfo, Option, OptionTypes } from 'components/types/types'
import { useNavigate } from 'react-router-dom';
import YupPassword from 'yup-password'
import clsx from 'clsx';
import { CorporateStepperContext } from '../../CorporateStepperContext';
import useMediaQuery from 'hook/useMediaQuery';
import { MediaTablet } from 'api/const/MediaQuery';
import { StepperHeader } from '../../../sharedComponents';
import { Logo } from 'components/atoms';
import { getReasonsList, getSectorsList, postCheckEmailAvailability } from 'api/Api';
import { StatusCode } from 'api/const';
import { GuestUser } from 'components/types/Api';
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext';
import MultiSelectComponent from 'components/atoms/Select/MultiSelectComponent';
import { MultiValue } from 'react-select';
import { emailRegex } from 'shared/const';

YupPassword(Yup)

const userInfoSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(3, 'Too Short!, min 3 char')
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
  lastName: Yup.string()
    .min(3, 'Too Short!, min 3 char')
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
  email: Yup.string()
    .matches(emailRegex, 'Wrong email format')
    .required('Please complete this required field.'),
  sectors: Yup.array()
    .min(1, 'Please select at least one field')
    .required('Please complete this required field.'),
  reasons: Yup.array()
    .required('Please complete this required field.')
    .min(1, "Please select at least one field")
    .of(
      Yup.object().shape({
        value: Yup.string(),
      })),
  reasonsHasDescription: Yup.boolean(),
  reasonsDescription: Yup.string().when("reasonsHasDescription", {
    is: (reasonsHasDescription: boolean) => reasonsHasDescription === true,
    then: Yup.string()
      .min(3, 'Too Short!, min 3 char')
      .max(250, 'Too Long!, max 250 char')
      .required('Please complete this required field.'),
    otherwise: Yup.string().notRequired()
  }),
  password: Yup.string().password()
    .min(8, 'Password must contain 8 or more characters with at least one of each: uppercase, lowercase, number and special')
    .minLowercase(1, 'Password must contain at least 1 lower case letter')
    .minUppercase(1, 'Password must contain at least 1 upper case letter')
    .minNumbers(1, 'Password must contain at least 1 number')
    .minSymbols(1, 'Password must contain at least 1 special character')
    .required('Please complete this required field.'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords doesen\'t match')
    .required('Please complete this required field.'),
});

export const StepCorporateUserInfo = (props: any) => {
  const navigate = useNavigate();
  const tablet = useMediaQuery(MediaTablet)
  const { setErrorModal } = useContext(AppGeneralContext)
  const ctx = useContext(CorporateStepperContext)

  const [userInfo] = useState<UserCompanyInfo>({
    ...ctx
  })

  const [sectorsSelected, setSectorsSelected] = useState<MultiValue<OptionTypes>>([])
  const [sectors, setSectors] = useState<OptionTypes[]>([])
  const [reasonSelected, setReasonsSelected] = useState<MultiValue<OptionTypes>>([])
  const [reasons, setReasons] = useState<OptionTypes[]>([])


  useEffect(() => {
    getSectorsList().then((res) => {
      let resp = res.response
      if (res.isSuccess && resp) {

        setSectors(resp.sectors ?? [])
      }
    })



    getReasonsList().then((res) => {
      let resp = res.response
      if (res.isSuccess && resp) {
        let reasonsOptionType = resp?.reasons.map(x => {
          return { value: x.value, label: x.label }
        })
        setReasons(reasonsOptionType ?? [])
      }
    })
  }, [])

  function isNotEmpty(par: string | undefined | null) {
    if (par === "" || par === undefined || par === null) {
      return false
    }
    return true
  }

  useEffect(()=>{
    formik.setFieldValue("sectors", sectorsSelected)
  },[sectorsSelected])

  const onChange = (option: MultiValue<OptionTypes>) => {
    if (option) {
      setSectorsSelected(option)
    }
  }

  useEffect(()=>{
    formik.setFieldValue("reasons", reasonSelected)

    if (reasonSelected.some(x => x.label.includes("Other"))) {
      formik.setFieldValue("reasonsHasDescription", true)
    } else {
      formik.setFieldValue("reasonsHasDescription", false)
      formik.setFieldValue("reasonsDescription", "")
    }
    
  },[reasonSelected])

  const onChangeReasons = (option: MultiValue<OptionTypes>) => {
    if (option) {
      setReasonsSelected(option)
      
    }
  }


  const formik = useFormik<UserCompanyInfo>({
    initialValues: userInfo,
    validationSchema: userInfoSchema,
    onSubmit: async (values, isValid) => {
      if (!isValid) {
        return
      }

      ctx.setFirstName(values.firstName)
      ctx.setLastName(values.lastName)
      ctx.setEmail(values.email)
      ctx.setPassword(values.password)
      ctx.setSectors(values.sectors)
      ctx.setReasons(values.reasons)
      ctx.setConfirmPassword(values.confirmPassword)
      if (values.reasonsHasDescription === true) {
        ctx.setReasonsHasDescription(true);
        ctx.setReasonsDescription(values.reasonsDescription)
      } else {
        ctx.setReasonsHasDescription(false);
      }

      props.nextStep()
    }
  })



  useEffect(() => {

    if (!formik.errors.email &&
      !!formik.touched.email &&
      isNotEmpty(formik.values.email) &&
      formik.values.email.includes("@") &&
      formik.values.email.includes(".")) {

      let req = { email: formik.values.email, isStartup: false }
      postCheckEmailAvailability(req).then((res) => {

        if (!res.isSuccess || !res.response) {
          setErrorModal(res.error)
          return false
        }

        if (!res.response.isAvailable) {
          setErrorModal(`${StatusCode.EMAIL_NOT_AVAIABLE}`)
          formik.setFieldError("email", "Email already used");
          return
        }

        if (!!res.response.existingGuestUser) {
          let user = res.response.existingGuestUser
          ctx.setFirstName(user.firstName);
          ctx.setLastName(user.lastName);
          ctx.setCompanyName(user.companyName);
          ctx.setCity(user.city.value);
          ctx.setCityOption(user.city);
          ctx.setGuestID(user.id);
        }
      })
    }
  }, [formik.errors.email, formik.touched.email, formik.values.email])


  useEffect(() => {
    if (isNotEmpty(ctx.firstName)) {
      formik.setFieldValue("firstName", ctx.firstName)
    } else {
      formik.setFieldValue("firstName", "")
    }
    if (isNotEmpty(ctx.lastName)) {
      formik.setFieldValue("lastName", ctx.lastName)
    } else {
      formik.setFieldValue("lastName", "")
    }
  }, [ctx.firstName, ctx.lastName])




  return (
    <div
      className={clsx(
        'pe-3 mt-3 mb-3  h-100',
        { 'd-none': !props.isActive },

      )} >
      <StepperHeader stepperTitle={'User Info'} />

      <form onSubmit={formik.handleSubmit} autoComplete='off'>

        {/* firstName*/}
        <label className='text-black mt-3' htmlFor="firstName">First Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='First Name'
          {...formik.getFieldProps('firstName')}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("firstName", true)}
          value={formik.values.firstName}
          name="firstName"
        />
        {formik.errors.firstName && formik.touched.firstName && <div className='text-error ms-2' id="firstName">{formik.errors.firstName}</div>}

        {/* lastName */}
        <label className='text-black mt-3' htmlFor="lastName">Last Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='Last Name'
          {...formik.getFieldProps('lastName')}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("lastName", true)}
          value={formik.values.lastName}
          name="lastName"
        />
        {formik.errors.lastName && formik.touched.lastName && <div className='text-error ms-2' id="lastName">{formik.errors.lastName}</div>}

        {/* email */}
        <label className='text-black mt-3' htmlFor="email">Company e-mail<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='Company e-mail'
          {...formik.getFieldProps('email')}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("email", true)}
          value={formik.values.email}
          name="email"
        />
        {formik.errors.email && formik.touched.email && <div className='text-error ms-2' id="email">{formik.errors.email}</div>}
        {/* sectors */}
        <label className='text-black mt-3' htmlFor="sectors">What technologies are you looking for ? <sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <MultiSelectComponent
          formik={formik}
          heightControlSection="47px"
          isSearchable
          setOptionSelected={onChange}
          placeholder="Please select a technology"
          className={"w-100 "}
          options={sectors}
          fieldName={'sectors'}
          value={sectorsSelected ? sectorsSelected : null}
          isNotFilter
        />
        {formik.touched?.sectors && formik.errors?.sectors && (
          <div className='fv-plugins-message-container mt-2'>
            <div className='fv-help-block'>
              <span className=' text-danger'  role='alert'>{formik.errors?.sectors?.toString()}</span>
            </div>
          </div>
        )}
        {/* reasons */}
        <label className='text-black mt-3' htmlFor="reasons">Why are you using Innovation Match? <sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <MultiSelectComponent
          heightControlSection="47px"
          isSearchable
          setOptionSelected={onChangeReasons}
          placeholder="Please select a reasons"
          className={"w-100 "}
          options={reasons}
          formik={formik}
          fieldName={'reasons'}
          value={reasonSelected ? reasonSelected : null}
          isNotFilter
        />
        {formik.touched?.reasons && formik.errors?.reasons && (
          <div className='fv-plugins-message-container mt-2'>
            <div className='fv-help-block'>
              <span className=' text-danger' role='alert'>{formik.errors?.reasons?.toString()}</span>
            </div>
          </div>
        )}

        {formik.values.reasonsHasDescription &&
          <div>
            {/* reasonsDescription */}
            <label className='text-black mt-3' htmlFor="reasonsDescription">Other</label>
            <textarea
              style={{ minHeight: "100px" }}
              placeholder=''
              {...formik.getFieldProps('reasonsDescription')}
              className="form-input py-2 "
              onChange={(e) => formik.setFieldValue("reasonsDescription", e.target.value)}
              onBlur={() => formik.setFieldTouched("reasonsDescription", true)}
              value={formik.values.reasonsDescription ? formik.values.reasonsDescription : undefined}
              name="reasonsDescription"
            />
            {formik.errors.reasonsDescription && formik.touched.reasonsDescription && <div className='text-danger ms-2' id="reasonsDescription">{formik.errors.reasonsDescription}</div>}
          </div>}

        {/* password */}
        <label className='text-black mt-3' htmlFor="password">Password<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='password'
          {...formik.getFieldProps('password')}
          className="form-input"
          type="password"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("password", true)}
          value={formik.values.password}
          name="password"
        />
        {formik.errors.password && formik.touched.password && <div className='text-error ms-2' id="password">{formik.errors.password}</div>}

        {/* confirmPassword */}
        <label className='text-black mt-3' htmlFor="confirmPassword">Confirm Password<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='confirm password'
          {...formik.getFieldProps('confirmPassword')}
          className="form-input"
          type="password"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("confirmPassword", true)}
          value={formik.values.confirmPassword}
          name="confirmPassword"
        />
        {formik.errors.confirmPassword && formik.touched.confirmPassword && <div className='text-error ms-2' id="confirmPassword">{formik.errors.confirmPassword}</div>}

        <div className="d-flex flex-row justify-content-between mt-4 mb-4  stepper_navigator">
          <button className="w-100 stepper_navigator_btn d-flex justify-content-start  align-items-center "
            onClick={() => { navigate("/getStarted") }} >
            <Logo className="w-20 first me-2 rotate-180 " colorLogo="#FF3F6B" />
            <span> Back </span>
          </button>
          <div className="ms-5 me-5" />
          <button className={clsx(" stepper_navigator_btn w-100 d-flex justify-content-end align-items-center ",
            { "btn-disabled": formik.isSubmitting || !formik.isValid || !formik.touched })}
            disabled={
              formik.isSubmitting
              || !formik.isValid
              || !formik.touched
            }
            type='submit'
          >
            <span>Next</span>
            <Logo className="w-20 first ms-2" colorLogo={"#FF3F6B"} />
          </button>
        </div>
      </form>
    </div>
  )
}


